<div class="space-y-3">
  <div class="bg-bg-surface-default space-y-5 rounded-xl p-8">
    <div class="pb-2">
      <h1 class="text-text-default text-lg font-bold">Data Keluarga</h1>
      <p class="text-text-subtler text-sm">Informasi Data Keluarga inti Karyawan</p>
    </div>
    <form
      class="space-y-3"
      [formGroup]="form">
      <div class="grid grid-cols-3 gap-5">
        <p class="text-text-default text-sm font-semibold">No. Kartu Keluarga (KK)</p>
        <div class="col-span-2">
          <div class="space-y-1">
            <app-input-number
              class="block"
              formControlName="kk_number"
              placeholder="Ketik No. Kartu Keluarga (KK)"
              [useGrouping]="false"
              (ngModelChange)="formService.resetError(formError, 'kk_number')" />
            @if (formError.kk_number.msg) {
              <p class="text-text-error text-xs">{{ formError.kk_number.msg }}</p>
            }
          </div>
        </div>
      </div>
      <div class="border-line-default border-b"></div>
      <div class="grid grid-cols-3 gap-5">
        <div class="space-y-1">
          <div class="flex items-center gap-1">
            <p class="text-text-default text-sm font-semibold">Foto Kartu Keluarga (KK)</p>
          </div>
        </div>
        <div class="col-span-2">
          <div class="space-y-1">
            <app-input-image
              class="block"
              formControlName="kk_image"
              boxStyleClass="border-solid !bg-bg-surface-default w-full"
              label="Upload Foto Kartu Keluarga (KK)"
              (remove)="form.controls.kk_image.setValue('')"
              (preview)="globalService.showImagePreview($event)"
              (ngModelChange)="formService.resetError(formError, 'kk_image')" />
            @if (formError.kk_image.msg) {
              <p class="text-text-error text-xs">{{ formError.kk_image.msg }}</p>
            }
          </div>
        </div>
      </div>
    </form>
    <div class="space-y-3">
      @for (family of form.controls.keluarga.controls; track family) {
        <form
          class="border-line-default rounded-xl border"
          [formGroup]="family">
          <div class="flex items-center justify-between gap-3 p-4">
            <p class="text-text-default text-lg font-bold">Data Keluarga #{{ $index + 1 }}</p>
            @if (form.controls.keluarga.controls.length > 1) {
              <app-button
                theme="tint-brand"
                [icon]="true"
                (click)="_remove($index)">
                <ic-trash-outline class="block h-6 w-6" />
              </app-button>
            }
          </div>
          <div class="border-line-default space-y-4 border-t p-4">
            <div class="space-y-1.5">
              <p class="text-text-subtle text-xs font-semibold">Nama</p>
              <div class="space-y-1">
                <app-input-text
                  class="block"
                  formControlName="name"
                  placeholder="Nama Keluarga Inti"
                  (ngModelChange)="formService.resetError(formError.keluarga[$index], 'name')" />
                @if (formError.keluarga[$index].name.msg) {
                  <p class="text-text-error text-xs">{{ formError.keluarga[$index].name.msg }}</p>
                }
              </div>
            </div>
            <div class="space-y-1.5">
              <p class="text-text-subtle text-xs font-semibold">No. Telepon</p>
              <div class="flex gap-2">
                <div class="space-y-1">
                  <app-input-phone-ext
                    class="block w-32"
                    formControlName="phone_ext"
                    (ngModelChange)="
                      formService.resetError(formError.keluarga[$index], 'phone_ext')
                    " />
                  @if (formError.keluarga[$index].phone_ext.msg) {
                    <p class="text-text-error text-xs">
                      {{ formError.keluarga[$index].phone_ext.msg }}
                    </p>
                  }
                </div>
                <div class="grow space-y-1">
                  <app-input-number
                    class="block"
                    formControlName="phone"
                    placeholder="Ketik No. Telepon"
                    [maxlength]="13"
                    [useGrouping]="false"
                    (ngModelChange)="formService.resetError(formError.keluarga[$index], 'phone')" />
                  @if (formError.keluarga[$index].phone.msg) {
                    <p class="text-text-error text-xs">
                      {{ formError.keluarga[$index].phone.msg }}
                    </p>
                  }
                </div>
              </div>
            </div>
            <div class="space-y-1.5">
              <p class="text-text-subtle text-xs font-semibold">Hubungan dengan Karyawan Sebagai</p>
              <div class="space-y-1">
                <app-input-radio
                  class="block"
                  mode="simple"
                  styleClass="flex w-max gap-3"
                  [options]="relationOption"
                  [(ngModel)]="relationSelected[$index]"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="_changeRelation($event, $index)" />
                @if (relationSelected[$index] === "Lainnya") {
                  <app-input-text
                    class="block"
                    formControlName="relation"
                    placeholder="Masukkan hubungan dengan karyawan"
                    (ngModelChange)="
                      formService.resetError(formError.keluarga[$index], 'relation')
                    " />
                }
                @if (formError.keluarga[$index].relation.msg) {
                  <p class="text-text-error text-xs">
                    {{ formError.keluarga[$index].relation.msg }}
                  </p>
                }
              </div>
            </div>
            <div class="space-y-1.5">
              <p class="text-text-subtle text-xs font-semibold">Jenis Kelamin</p>
              <div class="space-y-1">
                <app-input-radio
                  class="block"
                  formControlName="gender"
                  mode="simple"
                  styleClass="flex w-max gap-3"
                  [options]="genderOption"
                  (ngModelChange)="formService.resetError(formError.keluarga[$index], 'gender')" />
                @if (formError.keluarga[$index].gender.msg) {
                  <p class="text-text-error text-xs">{{ formError.keluarga[$index].gender.msg }}</p>
                }
              </div>
            </div>
          </div>
        </form>
      }
    </div>
    <app-button
      theme="tint-brand"
      (click)="add.emit()">
      &plus; Tambah Data
    </app-button>
  </div>
  <div class="flex items-center justify-between gap-3">
    <app-button
      theme="outline"
      class="block w-32"
      styleClass="bg-bg-surface-default"
      (click)="back.emit()">
      Kembali
    </app-button>
    <app-button
      class="ml-auto block w-32"
      (click)="_next()">
      Simpan
    </app-button>
  </div>
</div>
